import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ breakpoints: BP }) => ({
  pageContent: {
    display: 'flex',
  },
  content: {
    // minWidth: '96.5%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    margin: '0 20px',
    overflow: 'auto',
    transition: 'all ease 0.1s',
    border: '1px solid #E1E4EA',
    borderRadius: 8,
    marginTop: 20,
    padding: 20,
  },
  tableTopActions: {
    display: 'flex',
    padding: '0px 0px 10px',
    gap: 10,
    borderBottom: '1px solid #E1E4EA',
    marginBottom: 20,
    color: '#131517',
    fontSize: 22,
    fontWeight: 900,
  },
  tabLinksDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 680px)': {
      flexDirection: 'column',
      gap: '8px',
    },
  },
  tabLinks: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '10px',
    width: 'fit-content',
    padding: '8px 10px',
    background: '#F2F5F8',
    borderRadius: 8,
  },
  tabLinksBtnActive: {
    width: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#ffffff',
    fontsize: 16,
    fontWeight: 900,
    boxShadow: '0px 3px 1px 0px #0000000A',
    padding: '4px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    color: '#000',
    '@media (max-width: 1440px)': {
      fontSize: '14px',
    },
  },

  tabLinksBtn: {
    width: '100px',
    display: 'flex',
    fontSize: '16px',
    fontWeight: 900,
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f2f5f8',
    padding: '10px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 3px 8px 0px #0000001F',
    },
    '@media (max-width: 1440px)': {
      fontSize: '14px',
    },
  },
  profileTabs: {
    background: '#ffffff',
    margin: '0 20px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    justifyContent: 'space-between',
    borderRadius: '5px',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    '@media (max-width:763px)': {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  profileTabsBtn: {
    border: '1px solid #e5e5e5',
    color: '#777575',
    background: '#e5e5e5',
    width: 100,
  },
  activeProfileTabsBtn: {
    background: '#f8b100',
    border: '1px solid #f8b100',
    color: '#ffffff',
    width: 100,
    '&:hover': {
      background: '#f8b100',
    },
  },
  profileBtnsSpan: {
    display: 'flex',
    gap: '10px',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '14px 4px 5px',
    [BP.down('sm')]: {
      flexDirection: 'column',
      margin: '10px',
    },
  },
  card: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    // height: 160,
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    marginBottom: 5,
  },

  list: {
    margin: '20px 0 0px',
    width: '100%',
    minWidth: 1100,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    [BP.down('sm')]: {
      marginTop: 15,
      marginBottom: 10,
    },
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 15,
    '@media (max-width:1440px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width:1440px)': {
      marginTop: 10,
    },
  },
  row2: {
    display: 'flex',
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#303030',
  },
  tabsRow: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  titleView: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#303030',
    padding: 13,
    marginLeft: 16,
  },

  titleBlue: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1,
    color: '#007fff',
    margin: '0 20px 0 10px',
    cursor: 'pointer',
  },

  import: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
    cursor: 'pointer',
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 1,
    color: '#44a570',
    '& > svg': {
      height: 28,
      width: 28,
    },
  },

  printIcon: {
    height: 28,
    width: 28,
    fill: '#007fff',
    marginLeft: 10,
    cursor: 'pointer',
  },
  select: {
    width: '100%',
    fontFamily: 'Averta Light',
    '& > div': {
      border: 'solid 1px #707070',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
    },
    '& svg': {
      fill: '#f8b100',
    },
  },
  date: {
    boxSizing: 'border-box',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 4,
    justifyContent: 'center',
    fontFamily: 'Averta Light',
    border: 'solid 1px #707070',
    padding: '0 10px',
    '& input': {
      width: '100%',
      padding: 0,
      cursor: 'pointer',
      fontFamily: 'Averta Light',
    },
    '& svg': {
      fill: '#f8b100',
    },
    '& button': {
      padding: 8,
    },
  },
  loc: {
    '& svg': {
      fill: '#f8b100',
    },

    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
    '& > div': {
      border: 'solid 1px #707070',
    },
  },
  ml15: {
    marginLeft: 15,
  },
  input: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    border: 'solid 1px #707070',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
  },
  text: {
    fontFamily: 'Averta Light',
    fontSize: 13,
    fontWeight: 300,
    lineHeight: 1.5,
    color: '#303030',
  },
  but: {
    width: 77,
    height: 27,
    borderRadius: 5,
    backgroundColor: '#f8b100',
    fontFamily: 'Averta Light',
    fontSize: 12,
    fontWeight: 300,
    color: '#fff',
    padding: 0,
  },
  red: {
    backgroundColor: '#e4464b !important',
  },
  blue: {
    backgroundColor: '#007fff !important',
    marginLeft: 10,
  },
  rowRound: {
    width: 180,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    borderRadius: 20,
    backgroundColor: '#fff',
    fontFamily: 'Averta Light',
    fontSize: 15,
    fontWeight: 300,
    lineHeight: 1.27,
    color: '#9f9f9f',
    marginLeft: 25,
  },
  text2: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease-in',
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  tableRow: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    borderRadius: 4,
    border: '1px solid #E1E4EA',
    // boxShadow: '0px 0px 12px 0px #22232826',
    backgroundColor: '#fff',
    // margin: '10px 0',
    fontFamily: 'Averta',
    fontSize: 11,
    fontWeight: 300,
    color: '#43424b',
    textAlign: 'center',
    cursor: 'pointer',
    '& td': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
      minHeight: 20,
      width: '100px',
    },
    [BP.up('lg')]: {
      fontSize: 12,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
      display: 'flex',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  tableRowUnSeen: {
    minWidth: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    borderRadius: 4,
    border: '1px solid #E1E4EA',
    // boxShadow: '0px 0px 12px 0px #22232826',
    backgroundColor: '#fff',
    // margin: '10px 0',
    fontFamily: 'Averta',
    fontSize: 11,
    color: '#000000',
    fontWeight: 'bold',
    textAlign: 'center',
    cursor: 'pointer',
    '& td': {
      display: 'flex',
      alignItems: 'center',
      width: '100px',
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
    },
    [BP.up('lg')]: {
      fontSize: 12,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
      display: 'flex',
    },
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  emptyTableHandler: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40vh',
    width: '-webkit-fill-available',
    borderRadius: 8,
  },

  thead: {
    display: 'flex',
    fontFamily: 'Averta',
    fontSize: 10,
    color: '#999999',
    textAlign: 'center',
    alignItems: 'center',
    height: '42px',
    border: '1px solid #E1E4EA',
    borderRadius: '4px 0 4px 0',
    boxShadow:
      '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)',

    // marginBottom: '-10px',
    [BP.up('lg')]: {
      fontSize: 12,
    },
    '& div': {
      whiteSpace: 'nowrap',
      padding: 5,
    },
    '& th': {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      justifyContent: 'center',
      borderRight: '1px solid #E8E8E8',
    },
  },
  tbody: {
    // display: 'flex',
    // flexDirection: 'column',
    // width:'fit-content'
  },
  resText: {
    color: '#007fff',
  },
  bigText: {
    lineHeight: 2.7,
    color: '#303030',
  },
  bold: {
    fontFamily: 'Averta Bold',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 3.86,
    color: '#43424b',
  },
  editIcon: {
    height: 20,
    width: 20,
    fill: '#f8b100',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  replyIcon: {
    height: 20,
    width: 20,
    fill: '#000000',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  delIcon: {
    height: 20,
    width: 20,
    fill: '#e4464b',
    [BP.up('lg')]: {
      height: 25,
      width: 25,
    },
  },
  loading: {
    height: '100%',
    margin: 0,
  },
  tabActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& button': {
      padding: '5px',
    },
  },
  listContainer: {
    overflow: 'auto',
    width: '100%',
    minHeight: '70vh',
    boxSizing: 'border-box',
    transition: 'all ease 0.3s',
    '&::-webkit-scrollbar-track': {
      transition: 'all 1s ease',
      background: '#bebebe',
    },
    '&::-webkit-scrollbar-thumb': {
      transition: 'all 1s ease',
      borderRadius: '3px',
      background: '#494949',
    },
    '&::-webkit-scrollbar': {
      transition: 'all 1s ease',
      width: '8px',
    },
    // '&:hover': {
    //   transition: 'all 1s ease',
    //   '&::-webkit-scrollbar-track': {
    //     background: '#bebebe',
    //   },
    //   '&::-webkit-scrollbar-thumb': {
    //     borderRadius: '3px',
    //     background: '#494949',
    //   },
    // },
  },
  tableFilter: {
    display: 'flex',
    alignItems: 'center',
    width: '250px',
  },
  filterIcon: {
    marginRight: '-28px',
    marginTop: 4,
    zIndex: 1,
  },
  select: {
    width: '100%',
    fontFamily: 'Averta Light',
    '& > div': {
      // border: 'solid 1px #707070',
      minHeight: 36,
      // height: '35px !important',
      // flexWrap: 'nowrap',
    },
    '& .css-1pahdxg-control': {
      paddingLeft: '20px',
      borderRadius: 8,
    },

    '& > div:first-child': {
      paddingLeft: '20px',
      borderRadius: 8,
      '& > div:last-child': {
        height: 'auto',
        '& > span': {
          display: 'none',
        },
      },
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
      height: 29,
      height: 29,
    },
    // '& svg': {
    //   fill: '#f8b100',
    // },
  },
  statusSpanPreApproved: {
    background: '#EBF1FF',
    color: '#335CFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    width: 90,
    padding: '5px',
  },
  statusSpanReserved: {
    background: 'rgba(153, 160, 174, 0.16)',
    color: '#717784',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    width: 90,
    padding: '5px',
  },
  statusSpanApproved: {
    background: '#E8F8F0',
    color: '#178C4E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    width: 90,
    padding: '5px',
  },
  statusSpanRejected: {
    background: '#FFF1EB',
    color: '#E97135',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    width: 90,
    padding: '5px',
  },
  statusSpanDisputed: {
    background: '#FFEBEC',
    color: '#D02533',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 25,
    width: 90,
    padding: '5px',
  },
  checkbox: {
    padding: 5,
    '& svg': {
      fill: '#000',
      width: '20px',
    },
    '& hover': {
      background: '#f8b1001a',
    },
  },
  lastMsgNuSeenTd: {
    textAlign: 'left',
    gap: 5,
    alignItems: 'center',
    padding: '0px 5px',
    color: '#000000',
    fontWeight: 'bold',
    display: 'inline-block !important',
    overflow: 'hidden',
    width: '-webkit-fill-available',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',

    '&:hover': {
      color: '#335CFF',
      cursor: 'pointer',
    },
  },
  loadingMatchDiv: {
    position: 'fixed',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    backdropFilter: 'blur(3px)',
    backgroundColor: '#0000004a',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '2',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  MsgNuSeenTd: {
    display: 'flex',
    alignItems: 'flex-start !important',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  lastMsgTd: {
    justifyContent: 'flex-start !important',
    gap: 5,
    alignItems: 'center',
    padding: '0px 5px',
    textAlign: 'justify',
    display: 'inline-block !important',
    overflow: 'hidden',
    width: '-webkit-fill-available',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  dotSpan: {
    fontSize: '16px',
    lineHeight: 0,
    color: '#007fff',
  },
  fix: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#fff',
    transition: 'all 0.3s ease',
  },
  fixHeaderInbox: {
    background: '#f5f5f5',
    position: 'fixed',
    top: 65,
    overflowY: 'hidden' /* Hide vertical scrollbar */,
    overflowX: 'auto' /* Hide horizontal scrollbar */,
    scrollbarWidth: 'none',
    boxShadow: '0 0 8px 0px #00000066',
    zIndex: '20',
  },

  tableTopMargin: {
    marginTop: '50px',
  },
  tableTopMarginInbox: {
    marginTop: '80px',
  },

  appointmentTooltip: {
    // background: '#f8b1001a',
    width: 45,
    height: 45,
  },
  textInput: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    border: 'solid 1px #707070',
    marginTop: 5,
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
  },
  modal: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ShareEmail: {
    color: '#ffffff',
    background: '#007fff',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      color: '#ffffff',
      background: '#007fff',
    },
  },
  suggestionsContainer: {
    borderBottom: '1px solid rgb(218,220,224)',
    paddingBottom: '10px',
  },
  copyActions: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    gap: '6px',
    '& button': {
      padding: 6,
    },
  },
  copySection: {
    flexDirection: 'column',
    borderRadius: '4px',
    background: '#d5d5d5',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 10px',
    '& div': {
      flex: '1',
      paddingLeft: '10px',
    },
  },
  shareLinkContainer: {
    flex: '1',
  },
  modalBox: {
    width: '400px',
    minHeight: '397px',
    background: '#FFFFFF',
    borderRadius: '5px',
    padding: '10px 15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  shareLinkBox: {
    position: 'fixed',
    bottom: 15,
    left: 15,
    minHeight: '250px !important',
    zIndex: '9999',
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  containersTableContainer: {
    maxHeight: '300px',
    overflow: 'auto',
    flex: '1',
  },
  closeModal: {
    textAlign: 'end',
    '& img': {
      width: '10px',
      height: '10px',
      cursor: 'pointer',
    },
  },
  modalTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
    lineHeight: '23px',
    color: '#000000',
    margin: '0 0 20px 0',
  },
  editContainerInput: {
    background: 'transparent',
    padding: '4px 2px 5px 8px',
    borderRadius: '5px',
    border: '1px solid black',
  },
  updateContainersBtnSpan: {
    display: 'flex',
    justifyContent: 'space-between',
    justifyContent: 'flex-end',
  },
  updateContainersBtnClose: {
    background: '#007fff',
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    fontSize: '13px',
    padding: '10px 15px',
    margin: '15px',
    display: 'block',
  },
  updateContainersBtnSave: {
    background: '#3c845d',
    borderRadius: '5px',
    border: 'none',
    color: '#ffffff',
    fontSize: '13px',
    padding: '10px 15px',
    margin: '15px',
    display: 'block',
  },
  containerTable: {
    width: '100%',
    '& tr': {
      display: 'flex',
    },
    '& th': {
      color: '#777575',
      fontSize: '13px',
      padding: '10px',
    },
    '& td': {
      padding: '0 10px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#000000',
      fontSize: '13px',
      height: '27px',

      borderBottom: '1px solid #dedede',
      '& label': {
        margin: 0,
      },
      '& svg': {
        fill: '#000000',
      },
    },
  },
  containerChecBox: {
    accentColor: '#000000',
  },
  chassisNameContainer: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: 25,
      height: 25,
      margin: '0 10px',
    },
  },

  inviteIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '8px 0',
    borderBottom: '1px solid rgb(218,220,224)',
  },
  inviteIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontWeight: 'bold',
    borderBottom: '2px solid #007fff',
    padding: '10px 6px',
    color: '#007fff',
  },
  email: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  removeEmail: {
    width: 28,
    height: 28,
  },
  emailInputContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 5,
    borderBottom: '1px solid rgb(218,220,224)',
    paddingBottom: '8px',
    '& input': {
      flex: '1',
    },
  },
  emailBadge: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid rgb(218,220,224)',
    padding: '1.5px',
    borderRadius: '16px',
    gap: 6,
    width: 'fit-content',
  },
  emailAvatar: {
    width: 28,
    height: 28,
  },
  removeEmailIcon: {
    width: '1rem',
  },
  suggestion: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '3px 0',
  },
  suggestionInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  suggestionAvatar: {
    width: 30,
    height: 30,
  },
  emailCheckBox: {
    '& svg': {
      fill: '#007fff',
    },
    '& hover': {
      background: '#007fff45',
    },
  },

  circularLoader: {
    transform: 'rotate(-90deg)',
  },

  circleBackground: {
    fill: 'none',
    stroke: '#eee',
    strokeWidth: 5,
    animation: 'colorChange 1s infinite linear',
  },

  circleProgress: {
    fill: 'none',
    stroke: '#f8b100',
    strokeWidth: 5,
    strokeLinecap: 'round',
    transition: 'stroke-dasharray 0.5s ease',
  },
  circleFastProgress: {
    fill: 'none',
    stroke: '#ad7b0038',
    // stroke: '#f8b10030',
    strokeWidth: 5,
    strokeLinecap: 'round',
    animation: 'fastProgressLoop 1s infinite linear',
  },
  dicsounticon: {
    width: '24px',
    height: '24px',
  },
  badge: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: 900,
    fontSize: 14,
    marginLeft: 8,
  },
  dropdownContainer: {
    width: '230px',
    padding: '10px',
    backgroundColor: 'white',
    border: '1px solid #FFAD00',
    borderRadius: '6px',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    position: 'absolute',
    right: 40,
    top: 220,
  },
  dropdownBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    borderBottom: '1px solid #E1E4EA',
    padding: 8,
  },
  customCheckbox: {
    width: '16px',
    height: '16px',
    accentColor: '#007bff',
  },
  labelText: {
    fontSize: '14px',
    color: '#333',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '12px',
  },
  resetButton: {
    padding: '6px 25px',
    color: '#131617',
    border: '1px solid #000000',
    borderRadius: '6px',
    backgroundColor: 'white',
    cursor: 'pointer',
    fontSize: 14,
  },
  applyButton: {
    padding: '6px 25px',
    color: '#131617',
    backgroundColor: '#f4b400',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: 14,
    border: 'none',
  },
  directInboxIcon: {
    '& path': {
      stroke: '#000',
    },
  },
  selectContainer: {
    fontFamily: 'Averta',
    fontSize: 13,
    border: 'solid 1px #E1E4EA',
    padding: '0 10px',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 35,
    width: '230px',
    gap: 2,
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    color: '#99A0AE',
    position: 'relative',
    '&:hover': {
      border: 'solid 1px #0E121B',
      boxShadow: '0px 0px 0px 4px #99A0AE29',
    },
  },
  selectContainerActive: {
    fontFamily: 'Averta',
    fontSize: 13,
    border: 'solid 1px #0E121B',
    boxShadow: '0px 0px 0px 4px #99A0AE29',
    padding: '0 10px',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 35,
    width: '230px',
    gap: 2,
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    color: '#99A0AE',
    position: 'relative',
  },
  selectContainerLable: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 700,
    fontSize: 13,
    color: '#99A0AE',
  },
  arrowDownSelect: {
    marginLeft: 100,
  },
  popUpBackground: {
    backgroundColor: 'pink',
    width: '1000px',
    height: '1000px',
  },
  closeP: {
    cursor: 'pointer',
    marginLeft: 8,
  },
  optionContainer: {
    borderRadius: 20,
    border: '1px solid',
    flexDirection: 'row',
    display: 'flex',
    padding: '1px 8px',
    margin: '0 4px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    '& span': {
      fontSize: '12px',
    },
  },
  optionsShow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '16px 0',
    '& p': {
      fontSize: '14px',
      color: '#000',
      margin: '0 4px',
      fontFamily: 'Averta Bold',
      fontWeight: 'bold',
    },
  },

  longtext: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '@keyframes colorChange': {
    '0%': { stroke: '#ff0000' },
    '25%': { stroke: '#00ff00' },
    '50%': { stroke: '#0000ff' },
    '75%': { stroke: '#ffff00' },
    '100%': { stroke: '#ff0000' },
  },
  '@keyframes fastProgressLoop': {
    '0%': { strokeDasharray: '0, 100' },
    '100%': { strokeDasharray: '100, 0' },
  },
}));
